/* =============================================
   STICKY ADD-TO-CART BAR — masvital
   ============================================= */

(function () {
  'use strict';

  function initStickyATC() {
    const bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;

    const trigger = document.querySelector('.product__info-wrapper') || 
                    document.querySelector('[data-section-type="main-product"]') ||
                    document.querySelector('.product-form__buttons') ||
                    document.querySelector('.shopify-payment-button');

    if (!trigger) return;

    const qtyInput  = bar.querySelector('.sticky-atc__qty-input');
    const qtyMinus  = bar.querySelector('[data-action="minus"]');
    const qtyPlus   = bar.querySelector('[data-action="plus"]');
    const addBtn    = bar.querySelector('.sticky-atc__btn');
    const variantId = bar.dataset.variantId;
    // --- Sincronizar sticky con selector personalizado 1x / 2x ---
    const titleEl = bar.querySelector('.sticky-atc__title');
    const priceEl = bar.querySelector('.sticky-atc__current-price');
    const compareEl = bar.querySelector('.sticky-atc__compare-price');

    function syncStickyWithPack(selectedInput) {
      if (!selectedInput) return;

      const option = selectedInput.closest('.mv-pdp-pack__option');
      if (!option) return;

      const name = option.querySelector('.mv-pdp-pack__name');
      const offerPrice = option.querySelector('.mv-pdp-pack__offer');
      const comparePrice = option.querySelector('.mv-pdp-pack__compare');

      // Actualizar variante que agregará el sticky
      bar.dataset.variantId = selectedInput.value;

      // Actualizar nombre
      if (titleEl && name) {
        titleEl.textContent = name.textContent.trim();
      }

      // Actualizar precio actual
      if (priceEl && offerPrice) {
        priceEl.textContent = offerPrice.textContent.trim();
      }

      // Actualizar precio anterior
      if (compareEl && comparePrice) {
        compareEl.style.display = '';
        compareEl.textContent = comparePrice.textContent.trim();
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }

      // Una unidad equivale al SKU o pack seleccionado
      if (qtyInput) {
        qtyInput.value = selectedInput.dataset.quantity || 1;
      }

      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = 'AGREGAR AL CARRITO';
      }
    }

    // Sincronizar la opción preseleccionada al cargar
    const initialPack = document.querySelector(
      'input[name="mv_pack_variant"]:checked'
    );

    if (initialPack) {
      syncStickyWithPack(initialPack);
    }

    // Sincronizar cuando el usuario cambia entre 1x y 2x
    document.addEventListener('change', function (event) {
      const selectedInput = event.target.closest(
        'input[name="mv_pack_variant"]'
      );

      if (!selectedInput) return;

      syncStickyWithPack(selectedInput);
    });
    // --- Mostrar / ocultar al scroll ---
    const SCROLL_THRESHOLD = 150; // px desde el top para aparecer
    let ticking = false;

    function checkVisibility() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(checkVisibility);
        ticking = true;
      }
    }, { passive: true });

    // --- Cantidad ---
    qtyMinus.addEventListener('click', function () {
      const v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });

    qtyPlus.addEventListener('click', function () {
      const v = parseInt(qtyInput.value, 10);
      qtyInput.value = v + 1;
    });

    qtyInput.addEventListener('change', function () {
      if (parseInt(this.value, 10) < 1 || isNaN(parseInt(this.value, 10))) {
        this.value = 1;
      }
    });

    // Sincronizar con el selector de variante principal si existe
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        bar.dataset.variantId = e.detail.variant.id;

        // Actualizar precio
        const priceEl = bar.querySelector('.sticky-atc__current-price');
        const compareEl = bar.querySelector('.sticky-atc__compare-price');
        if (priceEl && e.detail.variant.price) {
          priceEl.textContent = formatMoney(e.detail.variant.price);
        }
        if (compareEl && e.detail.variant.compare_at_price) {
          compareEl.style.display = '';
          compareEl.textContent = formatMoney(e.detail.variant.compare_at_price);
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }

        // Deshabilitar botón si unavailable
        addBtn.disabled = !e.detail.variant.available;
        addBtn.textContent = e.detail.variant.available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
      }
    });

    // --- Agregar al carrito vía AJAX ---
    addBtn.addEventListener('click', function () {
      const currentVariantId = bar.dataset.variantId;
      if (!currentVariantId) return;

      const qty = parseInt(qtyInput.value, 10) || 1;
      addBtn.classList.add('loading');
      addBtn.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariantId, quantity: qty })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        addBtn.textContent = '✓ Agregado';
        setTimeout(function () {
          addBtn.classList.remove('loading');
          addBtn.textContent = 'AGREGAR AL CARRITO';
        }, 2000);

        // Refrescar mini-cart si existe
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Disparar evento de Shopify para actualizar el carrito nativo de Dawn
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          });
      })
      .catch(function () {
        addBtn.classList.remove('loading');
        addBtn.textContent = 'Error – reintentar';
        setTimeout(function () { addBtn.textContent = 'AGREGAR AL CARRITO'; }, 2500);
      });
    });
  }

  function formatMoney(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-CL');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }

})();